import { NgModule } from "@angular/core";
import { ModalModule } from "@modules/app-modal/modal.module";
import { CoreModule } from "@modules/core/core.module";
import { CustodyAccountBannerComponent } from "@modules/+new/custody_account/components/custody-account-banner/custody-account-banner.component";
import { CustodyAccountPreScreenModalComponent } from "@modules/+new/custody_account/components/custody-account-modal/prescreen/custody-account-prescreen-modal.component";
import { InfoItemComponent } from "@modules/+new/custody_account/components/custody-account-modal/info-item/info-item.component";

@NgModule({
	imports: [CoreModule, ModalModule],
	exports: [InfoItemComponent, CustodyAccountBannerComponent, CustodyAccountPreScreenModalComponent],
	declarations: [InfoItemComponent, CustodyAccountBannerComponent, CustodyAccountPreScreenModalComponent]
})
export class CustodyAccountModule {}
